'use client';

import { createBrowserClient } from '@supabase/ssr';
import { Capacitor } from '@capacitor/core';

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL!;
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

/**
 * 获取认证重定向 URL
 * Capacitor 环境使用自定义 deep link，Web 环境使用当前域名
 */
export function getAuthRedirectUrl(): string {
  if (typeof window === 'undefined') {
    return '/auth/callback';
  }
  
  const isCapacitor = Capacitor.isNativePlatform();
  if (isCapacitor) {
    return 'com.goodmark.projectfilter://auth/callback';
  }
  
  return window.location.origin + '/auth/callback';
}

/**
 * 浏览器端 Supabase 客户端
 * 支持 Web 和 Capacitor (Android/iOS)
 * 使用 @supabase/ssr 的 createBrowserClient 以支持自动 token 刷新
 */
export function createClient() {
  const isCapacitor = Capacitor.isNativePlatform();
  
  return createBrowserClient(supabaseUrl, supabaseAnonKey, {
    // Capacitor 环境下需要特殊配置
    auth: {
      // 使用自定义存储（Capacitor 需要 Preferences API）
      storage: isCapacitor
        ? {
            getItem: async (key: string) => {
              try {
                const { Preferences } = await import('@capacitor/preferences');
                const { value } = await Preferences.get({ key });
                return value;
              } catch (error) {
                console.error('[Supabase] Error getting from Preferences:', error);
                return null;
              }
            },
            setItem: async (key: string, value: string) => {
              try {
                const { Preferences } = await import('@capacitor/preferences');
                await Preferences.set({ key, value });
              } catch (error) {
                console.error('[Supabase] Error setting to Preferences:', error);
              }
            },
            removeItem: async (key: string) => {
              try {
                const { Preferences } = await import('@capacitor/preferences');
                await Preferences.remove({ key });
              } catch (error) {
                console.error('[Supabase] Error removing from Preferences:', error);
              }
            },
          }
        : undefined, // Web 环境使用默认 localStorage
    },
  });
}

